/**
 * 🏭 Factory para componentes com injeção de dependência
 * Facilita a criação de componentes com suas dependências injetadas
 */

import { useWebProvider } from '../hooks/defaults/useWebProvider'
import useUnidadeService from '../hooks/processo/useUnidadeForm'
import UnidadeForm from '../Screens/screens-commons/UnidadeForm'
import { useWebInterface } from '../Services/http/webInterface'
import UnidadeService from '../Services/processo/UnidadeService'
import { useToasts } from 'react-toast-notifications'

/**
 * Factory para UnidadeForm com dependências já injetadas
 */
export const createUnidadeFormFactory = () => {


    // Retornar componente com dependências injetadas
    return (props) => {
        // Criar instância do serviço (pode ser singleton se necessário)
        const webProvider = useWebProvider()
        const unidadeService = new UnidadeService(webProvider, useWebInterface)
        
        return <UnidadeForm
            unidadeService={unidadeService}
            useUnidadeForm={useUnidadeService}
            useWebProvider={useWebProvider}
            useWebInterface={useWebInterface}
            useToastService={useToasts}
            {...props}
        />
    }
}

export const UnidadeFormContainer = createUnidadeFormFactory()

/**
 * Para uso em rotas:
 * element: (props) => <UnidadeFormContainer {...props} />
 */